import React, { useContext } from 'react';
import TimeTableContext from '../context/timeTableContext'
import { getDaysOfWeek } from '../helpers/TimeTableHelpers'

const LessonBox = (fullInfo) => {
    const context = useContext(TimeTableContext);

    let daysOfWeek = getDaysOfWeek(context);
    let roomJsx = fullInfo.data.room_name.length ? <div className="room-info">חדר: {fullInfo.data.room_name}</div> : ""
    let changeTextFrom = fullInfo.data.changedFrom && fullInfo.data.changedFrom.hour !== "" ? <div className="badge badge-success">השיעור הועבר מ {daysOfWeek[fullInfo.data.changedFrom.day]} שעה {fullInfo.data.changedFrom.hour + context.state.firstHour}</div> : ""
    let changeTextTo = fullInfo.data.changedTo && fullInfo.data.changedTo.hour !== "" ? <div className="badge badge-danger">השיעור הועבר ל {daysOfWeek[fullInfo.data.changedTo.day]} שעה {fullInfo.data.changedTo.hour + context.state.firstHour}</div> : ""
    let cancelLesson = fullInfo.data.changes.voidReason ? <div className="badge badge-danger">ביטול שיעור<br />{fullInfo.data.changes.voidReason}</div> : ""

    console.log(fullInfo.data)
    return (
        <div>

            {changeTextTo}
            {changeTextFrom}
            <h6> {fullInfo.data.subject} </h6>
            <div className="name-timetable"> {fullInfo.data.name} </div>
            <div className="teahers-list">{fullInfo.data.classes}</div>

            <div className="teahers-list"> {fullInfo.data.teachers} </div>

            {roomJsx}
            {cancelLesson}
            <hr style={{ margiTop: "1px", marginBottom: "1px" }} />
        </div >
    );
};

export default LessonBox;